import React from 'react';
import { MapPin, FileText, Clock } from 'lucide-react';

// Reusable component for the service list items
const ServiceItem = ({ title, description, icon: IconComponent }) => (
  <div className="serviceItemWrapper">
    <div className="serviceIconWrapper">
      <IconComponent className="serviceIcon" />
    </div>
    <div className="serviceTextContent">
      <h3 className="serviceItemTitle">{title}</h3>
      <p className="serviceItemDescription">{description}</p>
    </div>
  </div>
);

const App = () => {
  return (
    <>
      <style>
        {`
        .serviceSectionContainer {
          min-height: 100vh;
          background-color: #1a237e; /* A deep blue for the background */
          color: #fff;
          padding: 4rem 1rem;
          display: flex;
          flex-direction: column;
          gap: 2rem;
          align-items: center;
          font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
        }

        @media (min-width: 768px) {
          .serviceSectionContainer {
            flex-direction: row;
            padding: 6rem;
            align-items: flex-start;
          }
        }

        .serviceContentBlock {
          max-width: 32rem;
        }
        
        @media (min-width: 768px) {
          .serviceContentBlock {
            flex-basis: 50%;
            margin-right: 2rem;
          }
        }

        .sectionHeaderTitle {
          font-size: 1.875rem;
          line-height: 2.25rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 1rem;
        }
        
        @media (min-width: 768px) {
            .sectionHeaderTitle {
                font-size: 3rem;
                line-height: 1;
              }
        }

        .serviceImageWrapper {
          display: none;
        }

        @media (min-width: 768px) {
          .serviceImageWrapper {
            display: block;
            flex-basis: 50%;
          }
        }
        
        .serviceMainImage {
          width: 100%;
          height: auto;
          border-radius: 1rem;
        }

        .serviceDescriptionText {
          font-size: 1rem;
          margin-bottom: 2rem;
          line-height: 1.5;
        }

        .serviceItemsList {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          margin-bottom: 2rem;
        }

        .serviceItemWrapper {
          background-color: #283593; /* A slightly lighter blue for the list items */
          border-radius: 0.75rem;
          padding: 1.5rem;
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        
        .serviceIconWrapper {
          background-color: #ef4444; /* The red icon background */
          border-radius: 9999px;
          padding: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
        }

        .serviceIcon {
          width: 1.5rem;
          height: 1.5rem;
          color: #fff;
        }
        
        .serviceTextContent {
          flex: 1;
        }

        .serviceItemTitle {
          font-size: 1.125rem;
          font-weight: 600;
          color: #fff;
        }

        .serviceItemDescription {
          font-size: 0.875rem;
          color: #d1d5db;
        }
        
        .contactActionBtn {
          background-color: #ef4444;
          color: #fff;
          font-weight: 700;
          padding: 1rem 2rem;
          border-radius: 9999px;
          text-align: center;
          cursor: pointer;
          transition: background-color 0.3s ease;
          border: none;
        }

        .contactActionBtn:hover {
          background-color: #dc2626;
        }

        `}
      </style>
      <div className="serviceSectionContainer">
        <div className="serviceContentBlock">
          <h2 className="sectionHeaderTitle">OUR SERVICE</h2>
          <p className="serviceDescriptionText">
            Based in Ogun State with comprehensive coverage across Lagos and Ogun. Our local presence ensures quick response times and deep understanding of regional preferences.
          </p>
          <div className="serviceItemsList">
            <ServiceItem
              title="Head Office: Ogun State"
              description="Main headquarters located in Ogun State."
              icon={MapPin}
            />
            <ServiceItem
              title="Service Areas: Lagos & Ogun States"
              description="Serving all major areas in Lagos and Ogun."
              icon={FileText}
            />
            <ServiceItem
              title="Response Time: Same day consultation"
              description="Quick and reliable same-day consultation service."
              icon={Clock}
            />
          </div>
          <button className="contactActionBtn">
            Contact Our Local Team
          </button>
        </div>
        <div className="serviceImageWrapper">
          <img
            src="https://placehold.co/600x400/1a237e/ffffff?text=Cityscape"
            alt="Cityscape"
            className="serviceMainImage"
          />
        </div>
      </div>
    </>
  );
};

export default App;
